import { render } from "./form-connect-text.vue?vue&type=template&id=24272966"
import script from "./form-connect-text.vue?vue&type=script&lang=js"
export * from "./form-connect-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__